
export default {
  async assertMatch(context, userid) {
    const requests = {
      mentee: 'getMyMentors',
      mentor: 'getMyMentees',
    };

    const myMatches = await context.dispatch(requests[context.getters.userTypeName]) || [];

    // find if userid exists in my matches
    return !!myMatches.find(match => match.user.id === userid);
  },
};
